import { useState } from 'react';
import styled from 'styled-components';
import theme from '~/styles/styledComponentsTheme';
import ContentGrid from '~/components/ContentGrid';
import {
  CONTENT_GRID_CONTENT_TYPE_VIDEO,
  CONTENT_GRID_CONTENT_SEARCH_TYPE_VIBE_TO_EVENT_STORY,
  CONTENT_GRID_CONTENT_SEARCH_TYPE_LOCATION_TO_EVENT_STORY,
  CONTENT_GRID_CONTENT_SORT_METHOD_MOST_RECENT,
} from '~/globals';
import { LoadMoreButton } from '~/components/buttons/LoadMoreButton';

const Container = styled.div`
  @media ${theme.breakpoints.isMobileOrTablet} {
    .lstvLinkNoStyle {
      display: block;
      margin: 16px 0;
    }
  }
`;

const LoadMoreContainer = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: center;
  padding-top: 50px;
`;

type Props = {
  /**
   * Initial videos such as from SSR hydration
   */
  videos?: any[];
  slug: string;
  offset?: number;
  totalVideos: number;
  isLocation?: boolean;
};

const VibeVideos = ({ videos, slug, offset = 0, totalVideos, isLocation }: Props) => {
  const [size, setSize] = useState(videos.length);

  const loadMore = () => {
    setSize(size + 8);
  };

  return (
    <Container>
      <ContentGrid
        content={videos}
        contentType={CONTENT_GRID_CONTENT_TYPE_VIDEO}
        contentSearchType={
          isLocation
            ? CONTENT_GRID_CONTENT_SEARCH_TYPE_LOCATION_TO_EVENT_STORY
            : CONTENT_GRID_CONTENT_SEARCH_TYPE_VIBE_TO_EVENT_STORY
        }
        contentSortMethod={CONTENT_GRID_CONTENT_SORT_METHOD_MOST_RECENT}
        numColumns={{ xs: 1, sm: 2 }}
        containerMode="grid"
        searchItems={slug}
        offset={offset}
        size={size}
      />
      {offset + size < totalVideos && (
        <LoadMoreContainer>
          <LoadMoreButton onClick={loadMore} />
        </LoadMoreContainer>
      )}
    </Container>
  );
};

export default VibeVideos;
